// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_comments_model from "./web_comments_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  t.revision = t.revision + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
  t.loading = false;
  t.dirty = false;
  t.pending_page = undefined;
}

function path(t) {
  const match = Curry._1(t.model, undefined).route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function" || !(match.TAG === /* Session */ 3 && !Mapre_web__Web_model.locked(Curry._1(t.model, undefined)))) {
    return;
  } else {
    return "/api/workspaces/" + (match._0 + ("/sessions/" + (match._2 + "/comments")));
  }
}

function active(t, gen) {
  if (gen === t.generation) {
    return path(t) !== undefined;
  } else {
    return false;
  }
}

function load(t, after, kind) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  if (t.loading) {
    if (kind === "Page" && after !== undefined) {
      t.pending_page = after;
    } else {
      t.dirty = true;
    }
    return;
  }
  t.loading = true;
  t.dirty = false;
  const gen = t.generation;
  const rev = t.revision;
  const url = after !== undefined ? path$1 + ("?after_id=" + after) : path$1;
  Mapre_web__Browser.request(t.controller, undefined, undefined, url).then(function (result) {
    if (active(t, gen)) {
      t.loading = false;
      if (rev !== t.revision) {
        t.dirty = true;
      } else if (result.TAG === /* Ok */ 0) {
        try {
          const match = Mapre_web__Web_comments_model.decode(result._0);
          const cursor = match[1];
          const items = match[0];
          Curry._1(t.emit, {
            TAG: /* Comments */ 47,
            _0: kind === "Page" ? ({
                TAG: /* Appended */ 1,
                _0: items,
                _1: cursor
              }) : (
                kind === "Poll" ? ({
                    TAG: /* Polled */ 2,
                    _0: items,
                    _1: cursor
                  }) : ({
                    TAG: /* Loaded */ 0,
                    _0: items,
                    _1: cursor
                  })
              )
          });
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.failure, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        const error = result._0;
        if (/* tag */ typeof error !== "object" && typeof error !== "function") {
          if (error === /* Unauthorized */ 0) {
            Curry._1(t.failure, error);
          }
          
        } else if (error.TAG === /* Missing */ 0) {
          Curry._1(t.failure, error);
        }
        
      }
      followup(t);
    }
    return Promise.resolve();
  });
}

function followup(t) {
  const cursor = t.pending_page;
  if (cursor !== undefined) {
    t.pending_page = undefined;
    return load(t, cursor, "Page");
  } else if (t.dirty) {
    return load(t, undefined, "Initial");
  } else {
    return;
  }
}

function refresh(t) {
  const tip = Mapre_web__Web_comments_model.tip(Curry._1(t.model, undefined).comments);
  if (tip !== undefined) {
    return load(t, tip, "Poll");
  } else {
    return load(t, undefined, "Initial");
  }
}

function send(t, attempt) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  t.revision = t.revision + 1 | 0;
  Curry._1(t.emit, {
    TAG: /* Comments */ 47,
    _0: {
      TAG: /* Started */ 4,
      _0: {
        id: attempt.id,
        text: attempt.text,
        uncertain: false
      }
    }
  });
  const gen = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, Mapre_web__Web_comments_model.body(attempt), path$1).then(function (result) {
    if (active(t, gen) && Stdlib__Option.fold(false, (function (a) {
        return a.id === attempt.id;
      }), Curry._1(t.model, undefined).comments.attempt)) {
      t.revision = t.revision + 1 | 0;
      if (result.TAG === /* Ok */ 0) {
        try {
          const action = {
            TAG: /* Posted */ 3,
            _0: Mapre_web__Web_comments_model.decode_posted(result._0)
          };
          Curry._1(t.emit, {
            TAG: /* Comments */ 47,
            _0: action
          });
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.failure, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        const error = result._0;
        if (/* tag */ typeof error !== "object" && typeof error !== "function") {
          switch (error) {
            case /* Unauthorized */ 0 :
              Curry._1(t.failure, error);
              break;
            case /* Forbidden */ 1 :
              Curry._1(t.emit, {
                TAG: /* Comments */ 47,
                _0: {
                  TAG: /* Failed */ 5,
                  _0: "Your role can read comments but cannot post them."
                }
              });
              refresh(t);
              break;
            case /* Invalid_response */ 2 :
              Curry._1(t.emit, {
                TAG: /* Comments */ 47,
                _0: /* Uncertain */ 0
              });
              refresh(t);
              break;
          }
        } else if (error.TAG === /* Missing */ 0) {
          Curry._1(t.failure, error);
        } else if (error._0 === "idempotency_key_reused") {
          Curry._1(t.emit, {
            TAG: /* Comments */ 47,
            _0: {
              TAG: /* Failed */ 5,
              _0: "Another comment already used this request. Refresh."
            }
          });
          refresh(t);
        } else {
          Curry._1(t.emit, {
            TAG: /* Comments */ 47,
            _0: /* Uncertain */ 0
          });
          refresh(t);
        }
      }
    }
    return Promise.resolve();
  });
}

function dispatch(t, action) {
  if (!/* tag */ (typeof action !== "object" && typeof action !== "function")) {
    return Curry._1(t.emit, {
      TAG: /* Comments */ 47,
      _0: action
    });
  }
  switch (action) {
    case /* Submit */ 1 :
      const m = Curry._1(t.model, undefined);
      if (Mapre_web__Web_model.can_create(m) && Mapre_web__Web_comments_model.can_submit(m.comments)) {
        return send(t, {
          id: crypto.randomUUID(),
          text: m.comments.draft,
          uncertain: false
        });
      } else {
        return;
      }
    case /* Retry */ 2 :
      const m$1 = Curry._1(t.model, undefined);
      if (Mapre_web__Web_model.can_create(m$1)) {
        return Stdlib__Option.iter((function (a) {
          if (a.uncertain) {
            return send(t, a);
          }
          
        }), m$1.comments.attempt);
      } else {
        return;
      }
    case /* Refresh */ 3 :
      return refresh(t);
    case /* More */ 4 :
      const cursor = Curry._1(t.model, undefined).comments.next_cursor;
      if (cursor !== undefined) {
        return load(t, cursor, "Page");
      } else {
        return;
      }
    default:
      return Curry._1(t.emit, {
        TAG: /* Comments */ 47,
        _0: action
      });
  }
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    revision: 0,
    controller: new AbortController(),
    loading: false,
    dirty: false,
    pending_page: undefined
  };
}

export {
  create,
  cancel,
  refresh,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
